import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Reveal from "../animations/Reveal";

function DonationSection() {
    const { t } = useTranslation();
    const tiers = [
        { amount: t("tier1Amount"), desc: t("tier1Desc"), featured: false },
        { amount: t("tier2Amount"), desc: t("tier2Desc"), featured: true, badge: t("tier2Badge") },
        { amount: t("tier3Amount"), desc: t("tier3Desc"), featured: false },
    ];
    const otherWays = [
        { label: t("otherBankTransfer"), to: "/donationDetails" },
        { label: t("otherDuitNow"), to: "/donate" },
        { label: t("otherOneTime"), to: "/donate" },
        { label: t("otherGoods"), to: "/donationDetails" },
    ];
    return (
        <section className="landing-section">
            <div className="container">
                <Reveal className="landing-donate-head">
                    <div>
                        <div className="landing-eyebrow">{t("donateEyebrow")}</div>
                        <h2 className="landing-heading">{t("donateTitle")}</h2>
                    </div>
                    <p className="landing-section-desc">{t("donateSubtitle")}</p>
                </Reveal>
                <Reveal className="landing-tiers" stagger={0.15}>
                    {tiers.map(tier => (
                        <div className={"landing-tier" + (tier.featured ? " landing-tier-featured" : "")} data-reveal key={tier.amount}>
                            {tier.badge && <span className="landing-tier-badge">{tier.badge}</span>}
                            <div className="landing-tier-amount">{tier.amount}<span className="landing-tier-per"> {t("tierPerMonth")}</span></div>
                            <p className="landing-tier-desc">{tier.desc}</p>
                            <Link className="landing-tier-btn" to="/donate">{t("tierCta")}</Link>
                        </div>
                    ))}
                </Reveal>
                <Reveal className="landing-other-ways" y={20}>
                    <span className="landing-other-title">{t("otherWaysTitle")}</span>
                    {otherWays.map(way => (
                        <Link className="landing-other-link" to={way.to} key={way.label}>{way.label}</Link>
                    ))}
                </Reveal>
            </div>
        </section>
    );
}
export default DonationSection;